/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeRoleCommand
 */
export interface ChangeRoleCommand {
    /**
     * 
     * @type {string}
     * @memberof ChangeRoleCommand
     */
    roleId: string;
}

/**
 * Check if a given object implements the ChangeRoleCommand interface.
 */
export function instanceOfChangeRoleCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roleId" in value;

    return isInstance;
}

export function ChangeRoleCommandFromJSON(json: any): ChangeRoleCommand {
    return ChangeRoleCommandFromJSONTyped(json, false);
}

export function ChangeRoleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRoleCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleId': json['roleId'],
    };
}

export function ChangeRoleCommandToJSON(value?: ChangeRoleCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roleId': value.roleId,
    };
}

